jQuery(document).ready(function ($) {
  $('.resp_menu .menu-item-has-children').click(function () {
    if ($(this).find('.sub-menu').hasClass('active')) {
      $(this).find('.sub-menu').removeClass('active');
    } else {
      $(this).find('.sub-menu').addClass('active');
    }
  });

  $('#menu-icon').click(function () {
    $('.sub-menu').removeClass('active');
  })
});